import { useFeature } from '@/hooks/use-feature';
import { useQuery } from '@apollo/client';
import { IS_EMQ_ENABLED_QUERY } from '../graphql/query';
import { IsEmqEnabledQuery } from '@/gql/graphql';

// Graphql is causing some linting errors, so we're disabling them for this file
export function useEmqScore(): boolean {
  const isFeatureEnabled = useFeature('EMQ_SCORE_DASHBOARD');

  const { data } = useQuery<IsEmqEnabledQuery>(IS_EMQ_ENABLED_QUERY, {
    skip: !isFeatureEnabled // Don't run the query if the feature is off
  });

  return Boolean(isFeatureEnabled && data?.merchant.emqScoreEnabled);
}
